import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/system';
import ActiveMinusIcon from '../../assets/active-minus.png';
import InactiveMinusIcon from '../../assets/inactive-minus.png';
import ActivePlusIcon from '../../assets/active-plus.png';
import InactivePlusIcon from '../../assets/inactive-plus.png';
import ActiveInputIcon from '../../assets/active-input.png';
import InactiveInputIcon from '../../assets/inactive-input.png';

const IconButton = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive: boolean }>(({ isActive }) => ({
  width: '30px',
  height: '30px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundImage: `url(${isActive ? ActiveMinusIcon : InactiveMinusIcon})`,
}));

const MinusButton = styled(IconButton)<{ isActive: boolean }>(({ isActive }) => ({
  backgroundImage: `url(${isActive ? ActiveMinusIcon : InactiveMinusIcon})`,
}));

const PlusButton = styled(IconButton)<{ isActive: boolean }>(({ isActive }) => ({
  backgroundImage: `url(${isActive ? ActivePlusIcon : InactivePlusIcon})`,
}));

const QuantityInput = styled('input', {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive: boolean }>(({ isActive }) => ({
  width: '55px',
  height: '30px',
  textAlign: 'center',
  border: 'none',
  backgroundImage: `url(${isActive ? ActiveInputIcon : InactiveInputIcon})`,
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  fontSize: '16px',
  fontWeight: 'bold',
  color: 'black',
  outline: 'none',
}));

interface QuantityControlProps {
  index: number;
  quantity: number;
  handleQuantityChange: (index: number, newQuantity: number) => void;
}

const QuantityControl = ({ index, quantity, handleQuantityChange }: QuantityControlProps) => {
  const isActive = quantity !== 0;

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <MinusButton
        isActive={isActive}
        onClick={() => handleQuantityChange(index, Math.max(0, quantity - 1))}
      />
      <QuantityInput
        type="text"
        pattern="\d*" // 数字のみを許可する
        inputMode="numeric"
        value={quantity || 0}
        isActive={isActive}
        onFocus={(e) => {
          if (e.target.value === '0') {
            e.target.value = '';
          }
        }}
        onBlur={(e) => {
          if (e.target.value === '') {
            handleQuantityChange(index, 0);
          }
        }}
        onChange={(e) => {
          const newValue = e.target.value;
          if (newValue.length <= 3) {
            handleQuantityChange(index, Math.max(0, parseInt(newValue) || 0));
          }
        }}
      />
      <PlusButton
        isActive={isActive}
        onClick={() => {
          if (quantity < 999) {
            handleQuantityChange(index, quantity + 1);
          }
        }}
      />
    </Box>
  );
};

export default QuantityControl;
